import { API_URL_FAQ } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditFaq from "types/Faq/createEditFaq";

const updateFaq = (uuid: string, editedItem: TCreateEditFaq) =>
  apiInstance({
    url: API_URL_FAQ + uuid,
    method: "put",
    data: editedItem,
  });

export default updateFaq;
